export default function (custom) {
  return {
    create: 'post',
    read: 'get',
    update: 'put',
    delete: 'delete',
    list: 'get',
    ...custom,
  };
}
